import {ConfigAST} from "../ast/ast.types";


/**
 * @description: 渲染态-页面数据
 * @return {*}
 */
export class AppData {
  instanceConfig: Map<string, ConfigAST> = new Map();
  instanceData: Map<string, Map<string, RenderDataSource>> = new Map();
  formList: any[] = []; // 所有的表单及对应字段
}


/**
 * @description: 渲染态-数据源数据
 * @return {*}
 */
export class RenderDataSource {
  items: any[] = []; // 业务表单数据
  paging: Paging = new Paging();
  initDataSource: boolean = true; // true初始化加载数据 false时一直加载数据
}

/**
 * @description: 渲染态-分页参数
 * @return {*}
 */
export class Paging {
  page: number = 1;
  size: number = 10;
  total?: number = 10;
  /** 滚动分页加载下一页时为 true，查询结果追加到已有 items */
  append?: boolean = false;
}


